import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trending-up",
  "use": "trending-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"trending-up\">\n<path d=\"M1,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.5-7.5c0.4-0.4,1-0.4,1.4,0l4.3,4.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0\n\ts0.4,1,0,1.4l-9.5,9.5c-0.4,0.4-1,0.4-1.4,0l-4.3-4.3l-6.8,6.8C1.5,18.9,1.3,19,1,19z\" />\n<path d=\"M23,13c-0.6,0-1-0.4-1-1V7h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1v6C24,12.6,23.6,13,23,13z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol